export enum FormEvents {
  WRITING_IN_FORM = 'writing_in_form',
  CHANGE_FORM_FIELD = 'change_form_field',
}

export enum FormNames {
  LOGIN = 'login',
  REGISTER = 'register',
  USER_SETTING = 'user_setting',
  BOOK_A_TUTOR = 'book_tutor',
  VIDEO_CHAT = 'video_chat',
  ONBOARDING_DETAILS = 'onboarding_detail_form',
}
